export const pickupSort = "Læssedato";
export const dropoffSort = "Lossedato";
export const ldmSort = "Ladmeter";
export const createdAtSort = "Tilføjet";
export const pickupPostCodeSort = "PickupPostcode";
export const dropoffPostCodeSort = "DropoffPostcode";
export const clientSort = "Client";
export const label = "Label";

export const allSortProperties = [
  label,
  pickupSort,
  dropoffSort,
  ldmSort,
  createdAtSort,
  pickupPostCodeSort,
  dropoffPostCodeSort,
  clientSort,
];

export type SortOrder = "ASC" | "DESC";

export type SortProperty =
  | typeof pickupSort
  | typeof dropoffSort
  | typeof ldmSort
  | typeof createdAtSort
  | typeof pickupPostCodeSort
  | typeof dropoffPostCodeSort
  | typeof clientSort
  | typeof label;

export type FilterType = "cargos" | "routes";
